/* assets/halo-toolcart.js — optimized (non-breaking) */

class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      // Use currentTarget for reliability even if child is clicked
      button.addEventListener('click', (event) => {
        const id = (event.currentTarget && event.currentTarget.dataset && event.currentTarget.dataset.popup) || '';
        if (!id) return;
        const target = document.getElementById(id);
        const drawer = document.querySelector('.previewCart');
        if (!target || !drawer) return;

        // Batch writes; avoid sync style flushes
        requestAnimationFrame(() => {
          target.classList.add('show');
          drawer.classList.add('active-tool');
        });
      }, { passive: true });
    });
  }
}
customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    const btn = this.querySelector('button');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const opened = document.querySelector('.popup-toolDown.show');
      const drawer = document.querySelector('.previewCart');
      requestAnimationFrame(() => {
        if (opened) opened.classList.remove('show');
        if (drawer) drawer.classList.remove('active-tool');
      });
    }, { passive: true });
  }
}
customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    const trigger = this.querySelector('[data-update-note]');
    if (!trigger) return;

    trigger.addEventListener('click', () => {
      const ta = this.querySelector('.text-area');
      const val = ta ? ta.value : '';
      const body = JSON.stringify({ note: val });
      try {
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body });
      } catch (_) {}
      const opened = document.querySelector('.popup-toolDown.show');
      const drawer = document.querySelector('.previewCart');
      requestAnimationFrame(() => {
        if (opened) opened.classList.remove('show');
        if (drawer) drawer.classList.remove('active-tool');
      });
    }, { passive: true });
  }
}
customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();

    const input = this.querySelector('input[name="discount"]');
    const trigger = this.querySelector('[data-update-coupon]');
    if (!input || !trigger) return;

    // Restore saved code
    try {
      const saved = localStorage.getItem('storedDiscount');
      if (saved) input.value = saved;
    } catch (_) {}

    trigger.addEventListener('click', () => {
      const code = (input.value || '').trim();
      try { localStorage.setItem('storedDiscount', code); } catch (_) {}

      // Hit Shopify discount route (sets cookie)
      // No need to parse body; just fire-and-forget
      if (code) {
        fetch(`/discount/${encodeURIComponent(code)}`).catch(() => {});
      }

      const opened = document.querySelector('.popup-toolDown.show');
      const drawer = document.querySelector('.previewCart');
      requestAnimationFrame(() => {
        if (opened) opened.classList.remove('show');
        if (drawer) drawer.classList.remove('active-tool');
      });
    }, { passive: true });
  }
}
customElements.define('coupon-code', CouponCode);

/* === Free Shipping Notice (dynamic, debounced updates) === */
(function () {
  var notice = document.getElementById('FreeShippingNotice');
  if (!notice) return;

  var THRESHOLD = parseInt(notice.getAttribute('data-threshold'), 10);
  if (!isFinite(THRESHOLD)) THRESHOLD = 399900; // cents fallback
  var CURRENCY  = notice.getAttribute('data-currency')
                || (window.Shopify && Shopify.currency && Shopify.currency.active)
                || (window.Shopify && Shopify.Currency && Shopify.Currency.displayFormat)
                || 'USD';

  var inFlight  = false;
  var debounceT = null;
  var DEBOUNCE_MS = 150;

  function formatMoney(cents, currencyCode) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(cents); } catch (_) {}
    }
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode || 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format((cents || 0) / 100);
    } catch (_) {
      return ((cents || 0) / 100).toFixed(2);
    }
  }

  function setUI(totalCents, currencyCode) {
    var remaining = Math.max(THRESHOLD - totalCents, 0);
    var unlocked  = remaining === 0;

    var textWrap  = notice.querySelector('.free-shipping__text');
    var barFill   = notice.querySelector('.free-shipping__bar-fill');
    var pct       = Math.min(100, (totalCents / THRESHOLD) * 100);

    // Batch DOM writes; minimize layout work
    requestAnimationFrame(function () {
      if (textWrap) {
        if (unlocked) {
          textWrap.innerHTML = '<span class="free-shipping__msg free-shipping__msg--unlocked">🎉 Free shipping unlocked!</span>';
        } else {
          textWrap.innerHTML = '<span class="free-shipping__msg free-shipping__msg--progress">You’re only <strong class="free-shipping__remaining">'
            + formatMoney(remaining, currencyCode) +
            '</strong> away from FREE shipping.</span>';
        }
      }
      if (barFill) {
        barFill.style.width = (isFinite(pct) ? pct : 0) + '%';
      }
      notice.classList.toggle('is-unlocked', unlocked);
      notice.classList.toggle('is-progress', !unlocked);
    });
  }

  function updateFromCart(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;
    setUI(cart.total_price, cart.currency || CURRENCY);
  }

  function fetchCartAndUpdate() {
    if (inFlight) return;
    inFlight = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateFromCart(cart); })
      .catch(function () { /* noop */ })
      .finally(function () { inFlight = false; });
  }

  function scheduleUpdate() {
    if (debounceT) clearTimeout(debounceT);
    debounceT = setTimeout(fetchCartAndUpdate, DEBOUNCE_MS);
  }

  // 1) Initial paint from Liquid data, then ensure accuracy via /cart.js
  (function bootstrap() {
    var initial = parseInt(notice.getAttribute('data-cart-total'), 10);
    if (!isNaN(initial)) setUI(initial, CURRENCY);
    setTimeout(fetchCartAndUpdate, 60);
  })();

  // 2) Listen for common custom events (if theme emits them)
  document.addEventListener('cart:updated', function (e) {
    if (e && e.detail && e.detail.cart) updateFromCart(e.detail.cart);
    else scheduleUpdate();
  });
  document.addEventListener('cart:change', scheduleUpdate);
  document.addEventListener('cart:add', scheduleUpdate);
  document.addEventListener('cart:remove', scheduleUpdate);

  // 3) MutationObserver fallback, debounced
  var drawer = notice.closest('#halo-cart-sidebar, .halo-cart-sidebar, #CartDrawer, .cart-drawer, .drawer, .side-cart') || notice.parentElement;
  if (drawer && 'MutationObserver' in window) {
    var mo = new MutationObserver(function () { scheduleUpdate(); });
    mo.observe(drawer, { childList: true, subtree: true });
  }

  // 4) Intercept fetch → schedule update ONLY for /cart endpoints (no response cloning)
  try {
    var _fetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var req = args[0];
      var url = typeof req === 'string' ? req : (req && req.url ? req.url : '');
      return _fetch.apply(this, args).then(function (resp) {
        try {
          // Prefer response.url when available
          var respUrl = (resp && resp.url) ? resp.url : url;
          if (respUrl && respUrl.indexOf('/cart') !== -1) scheduleUpdate();
        } catch (_) {}
        return resp;
      });
    };
  } catch (_) { /* noop */ }

  // Manual hook (public)
  window.HaloFreeShipping = { refresh: scheduleUpdate, threshold: THRESHOLD };
})();
